import { Injectable } from '@angular/core';
import { SlotModel } from '../models/slot-model';

import { TimeDisplayPipe } from '@bayclubs/utils';

@Injectable({
    providedIn: 'root'
})
export class SlotProviderService {
    constructor() {}

    public getDailySlots(): Array<SlotModel> {
        return this.getDailySlotsFrom(15);
    }

    public getDailySlotsFrom(from: number): Array<SlotModel> {
        let timeDisplay = new TimeDisplayPipe();

        let intervalInMinutes = 15;

        let slots: Array<SlotModel> = [];
        for (let i = from; i <= 1440; i += intervalInMinutes) {
            slots.push(new SlotModel(i, timeDisplay.transform(i)));
        }

        return slots;
    }
}
